export default {
    chooseJobtitlesText: () => JIX.Gettext.__("Din jobtitel"),
    chooseGeoAreasText: () => JIX.Gettext.__("Område"),
    chooseEducationLevelText: () => JIX.Gettext.__("Uddannelse"),
    chooseJobexperienceText: () => JIX.Gettext.__("Erhvervserfaring"),
    chooseMgrexperienceText: () => JIX.Gettext.__p("Abbrev. in English", "Ledelseserfaring"),
    chooseAgeText: () => JIX.Gettext.__("Alder"),
    ageText: () => JIX.Gettext.__("år"),
    updateText: () => JIX.Gettext.__("Opdatér"),
    resetText: () => JIX.Gettext.__("Nulstil"),
    readMoreText: () => JIX.Gettext.__("Læs mere"),
    readLessText: () => JIX.Gettext.__("Læs mindre"),
    numberOfCVsText: () => JIX.Gettext.__("Antal CV'er"),
    explanationText1: () => JIX.Gettext.__("Grafen viser, hvordan lønniveauet fordeler sig for din søgning. Du kan fx se, hvad flest tjener, og om der er stor forskel på højeste og laveste løn."),
    explanationText2: () => JIX.Gettext.__("Lønniveauet er beregnet ud fra lønoplysninger fra CV'er i vores database. Tallene er brutto (inkl. pension) og er oplyst af brugerne selv. Vi kan ikke garantere for nøjagtigheden."),
    averageSalaryText: () => JIX.Gettext.__("Gennemsnitlig månedsløn"),
    krText: () => JIX.Gettext.__("kr."),
};
